import {alt} from 'epic-react-common';
import {registerLocalizationStore} from 'epic-react-common';

export default registerLocalizationStore(alt);
